import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import AdminManagementPage from "./pages/AdminManagement/AdminManagementPage";
import NewsPage from "./pages/News/NewsPage";
import AIManagementPage from "./pages/AIManagement/AIManagementPage";
import ReportsPage from "./pages/Reports/ReportsPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import SearchManagementPage from "./pages/SearchManagement/SearchManagementPage";
import AuditLogsPage from "./pages/AuditLogs/AuditLogsPage";

import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout/AppLayout";
import { getToken } from "./api/client";

const isAuthenticated = () => {
  return getToken() !== null;
};

const ComingSoon = ({ title }) => (
  <div
    style={{
      background: "#ffffff",
      border: "1px solid #edf0f5",
      borderRadius: 22,
      padding: 30,
      boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
      fontWeight: 800,
    }}
  >
    {title} module coming soon.
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated()}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="ai-management" element={<AIManagementPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="administrative" element={<AdminManagementPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="searchmanagement" element={<SearchManagementPage />} />
        </Route>

        <Route
          path="*"
          element={
            isAuthenticated() ? <Navigate to="/" /> : <Navigate to="/login" />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
